export default function HomePage() {
  return (
    <div className="join-page">
      <div className="join-card card border-0 shadow-sm">
        <div className="card-body p-4">
          <p className="join-wordmark">Artemis</p>
          <p className="join-subtitle mb-0">
            Looking to join Artemis? Ask your friend for a referral link.
          </p>
        </div>
      </div>
    </div>
  )
}
